/* SAISIR EN MENSUEL OU EN CUMULÉ (2026-10-20) : la base garde des montants MENSUELS ; en mode cumulé, la grille
   du CA réalisé montre et reçoit des cumuls depuis janvier, que l'on convertit ici.

   Poser un cumul sur un mois fixe le montant de CE mois (le cumul tapé moins celui d'avant) ; le cumul des
   mois suivants reste ce qu'il était, le mois d'après absorbant l'écart. Sans données après lui, rien d'autre
   ne bouge. */
const r2 = (x) => Math.round(x * 100) / 100;

export const cumulAt = (mv, c) => (c < 0 ? 0 : r2(mv.slice(0, c + 1).reduce((a, v) => a + (Number(v) || 0), 0)));

/* Ce que la cellule affiche : le mois, ou le cumul jusqu'à lui. */
export const lu = (mv, c, cumul) => (cumul ? cumulAt(mv, c) : Number(mv[c]) || 0);

/* Un cumul se lit jusqu'au dernier mois qui porte une donnée, et sur tous les mois clos : après, il se
   répéterait sans rien dire. En mensuel, toutes les cellules se lisent. */
export const visible = (mv, c, cumul, clos = 12) => !cumul || c < clos || mv.slice(c).some((v) => (Number(v) || 0) !== 0);

/* Pose la valeur LUE d'un mois et rend les douze montants mensuels. */
export function poser(mv, c, valeur, cumul) {
  const out = mv.map((v) => Number(v) || 0);
  if (!cumul) { out[c] = r2(valeur); return out; }
  const ancien = out[c];
  const nouveau = r2(valeur - cumulAt(out, c - 1));
  out[c] = nouveau;
  if (c < 11 && out.slice(c + 1).some((v) => v !== 0)) out[c + 1] = r2(out[c + 1] + (ancien - nouveau));
  return out;
}
